/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_BulgarianInputs */

const en_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulgarian`)
};

const fr_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulgare`)
};

const de_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bulgarisch`)
};

const it_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bulgaro`)
};

const ru_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`болгарский`)
};

const es_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`búlgaro`)
};

const zh_cn2_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保加利亚语`)
};

const ja_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブルガリア語`)
};

const hi_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बल्गेरियाई`)
};

const pt_pt2_speechmatics_target_language_bulgarian = /** @type {(inputs: Speechmatics_Target_Language_BulgarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`búlgaro`)
};

/**
* | output |
* | --- |
* | "Bulgarian" |
*
* @param {Speechmatics_Target_Language_BulgarianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_bulgarian = /** @type {((inputs?: Speechmatics_Target_Language_BulgarianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_BulgarianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_bulgarian(inputs)
	if (locale === "de") return de_speechmatics_target_language_bulgarian(inputs)
	if (locale === "it") return it_speechmatics_target_language_bulgarian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_bulgarian(inputs)
	if (locale === "es") return es_speechmatics_target_language_bulgarian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_bulgarian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_bulgarian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_bulgarian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_bulgarian(inputs)
	return en_speechmatics_target_language_bulgarian(inputs)
});